export type { Props as IconCardLayoutProps } from './icon-card-layout';
export { default as IconCardLayout } from './icon-card-layout';
export { ResultContainer, ResultContentContainer, IconContainer } from './styled';
